/**
 * Mode penyedia AI teks (v2/M1). Slot `chat` memegang profil Claude (kredensial
 * yang sudah ada), slot `chat_backup` memegang profil OpenAI. Mode hanya memilih
 * slot mana yang menjadi Utama; kunci tidak pernah dipindah atau dihapus.
 */

export const PROVIDER_MODES = ["claude_chatgpt", "chatgpt_only"] as const;
export type ProviderMode = (typeof PROVIDER_MODES)[number];

/** Bawaan = perilaku sebelum v2 (Utama = Claude). */
export const DEFAULT_PROVIDER_MODE: ProviderMode = "claude_chatgpt";

/** Slot profil OpenAI. (`reasoning_effort` ditentukan per MODEL, bukan per slot — lihat `provider/reasoning-model`.) */
export const BACKUP_SLOTS = ["chat_backup", "pointer_backup"] as const;
export type BackupSlot = (typeof BACKUP_SLOTS)[number];

export type ChatPrimarySlot = "chat" | "chat_backup";

/** Slot Chat yang menjadi profil Utama untuk tiap mode. */
export const PRIMARY_CHAT_SLOT: Record<ProviderMode, ChatPrimarySlot> = {
	claude_chatgpt: "chat",
	chatgpt_only: "chat_backup",
};

/** Lawan tiap profil Chat: Cadangan failover = profil yang BUKAN Utama mode itu. */
export const OPPOSITE_CHAT_SLOT: Record<ChatPrimarySlot, ChatPrimarySlot> = {
	chat: "chat_backup",
	chat_backup: "chat",
};

/** Slot Pointer yang boleh menimpa slot Chat (bila terisi) untuk tiap mode. */
export const PRIMARY_POINTER_SLOT: Record<
	ProviderMode,
	"pointer" | "pointer_backup"
> = {
	claude_chatgpt: "pointer",
	chatgpt_only: "pointer_backup",
};

export const PROVIDER_MODE_LABELS: Record<ProviderMode, string> = {
	claude_chatgpt: "Claude + ChatGPT",
	chatgpt_only: "ChatGPT saja",
};

/** Kolom DB berupa string bebas; nilai tak dikenal jatuh ke bawaan (perilaku lama). */
export function normalizeProviderMode(raw: unknown): ProviderMode {
	return (PROVIDER_MODES as readonly unknown[]).includes(raw)
		? (raw as ProviderMode)
		: DEFAULT_PROVIDER_MODE;
}

export function isBackupSlot(slot: string): slot is BackupSlot {
	return (BACKUP_SLOTS as readonly string[]).includes(slot);
}

export interface ModeRateWarning {
	/** Slot profil OpenAI yang model-nya belum punya tarif token lengkap. */
	slot: BackupSlot;
	model: string;
}

/** Profil siap/tidak untuk satu mode — dasar tombol simpan & pesan penolakan. */
export interface ProviderModeStatusDto {
	mode: ProviderMode;
	/** Mode mana yang bisa disimpan sekarang (profil Utamanya terisi). */
	available: Record<ProviderMode, boolean>;
	/** Model profil OpenAI yang belum punya tarif di kartu Tarif model. */
	missingRates: ModeRateWarning[];
}

export interface ProviderModeUpdate {
	mode: ProviderMode;
}

export const PROVIDER_MODE_MESSAGES = {
	needOpenAi: "Lengkapi kunci OpenAI dulu (kartu Chat cadangan).",
	needClaude: "Lengkapi kunci Claude dulu (kartu Chat).",
	cryptoMissing:
		"AI_CREDENTIALS_KEY belum diset di server — kunci tidak bisa dibaca.",
} as const;
